/**
 * Where a panel opened from an element may be drawn without being cut off. A box that
 * scrolls or hides what overflows it clips a panel inside it, and the window clips everything.
 */

/** The edges a panel must stay inside: on each axis, the nearest box that clips what overflows it on that axis, and the window. */
export function roomFor(element: HTMLElement): {
  top: number;
  bottom: number;
  left: number;
  right: number;
} {
  const room = {
    top: 0,
    bottom: window.innerHeight,
    left: 0,
    right: window.innerWidth,
  };
  let vertical = false;
  let horizontal = false;
  for (let at = element.parentElement; at !== null; at = at.parentElement) {
    const style = getComputedStyle(at);
    const clipsY = !vertical && style.overflowY !== "visible";
    const clipsX = !horizontal && style.overflowX !== "visible";
    if (!clipsY && !clipsX) continue;
    const edges = at.getBoundingClientRect();
    if (clipsY) {
      room.top = Math.max(room.top, edges.top);
      room.bottom = Math.min(room.bottom, edges.bottom);
      vertical = true;
    }
    if (clipsX) {
      room.left = Math.max(room.left, edges.left);
      room.right = Math.min(room.right, edges.right);
      horizontal = true;
    }
    if (vertical && horizontal) break;
  }
  return room;
}
